module.exports = __webpack_public_path__ + "img/cozinha-xpto.80d67638.webp";